(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kloshy-pyjama-motifs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const open=event.target.closest('[data-kp-open]');
  if(open){const dialog=document.getElementById(open.dataset.kpOpen);if(dialog)dialog.showModal();return;}
  const close=event.target.closest('[data-kp-close]');
  if(close){close.closest('dialog').close();return;}
  if(event.target.matches('dialog.kp-motifs__dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
